import * as React from "react";

interface IDetailsIconProps {
  height?: number | string;
  width?: number | string;
  className?: string;
}

export default class DetailsIcon extends React.PureComponent<
  IDetailsIconProps
> {
  render() {
    return (
      <svg
        className={this.props.className}
        viewBox="0 0 512 512"
        style={{ height: this.props.height, width: this.props.width }}
      >
        <path d="M437.02,74.98C388.667,26.629,324.38,0,256,0S123.333,26.629,74.98,74.98C26.629,123.333,0,187.62,0,256   c0,45.105,11.836,89.231,34.286,128.041L0,512l127.959-34.286C166.769,500.164,210.895,512,256,512   c68.38,0,132.667-26.629,181.02-74.98C485.371,388.667,512,324.38,512,256S485.371,123.333,437.02,74.98z M271,383.5h-30v-30h30   V383.5z M311.892,253.498L271,299.229V323.5h-30v-35.729l48.533-54.276C296.93,225.232,301,214.581,301,203.5   c0-24.813-20.187-45-45-45s-45,20.187-45,45h-30c0-41.355,33.645-75,75-75s75,33.645,75,75   C331,221.975,324.214,239.73,311.892,253.498z" />
      </svg>
    );
  }
}
